import React from "react";
import TreeEditTopic from "../../Courses/EditCourse/TreeEditTopic";

const DisciplineEditTocs = ({ id }) => {
    return <div>
        <TreeEditTopic isProfession={true} courseId={id} ></TreeEditTopic>
    </div>
}

export default DisciplineEditTocs;